import { MapperBase } from '../../utilities/mapper-base';
import { DepartmentResource } from '../resource/department.resource';
import { Department } from '../ui/department.model';
import { EmployeeRoleResourceToRoleMapper } from './employee-role-resource-to-role.mapper';

export class DepartmentResourceToDepartmentMapper extends MapperBase<DepartmentResource, Department> {
	map(source: DepartmentResource): Department {
		const dest = new Department();
		const mapper = new EmployeeRoleResourceToRoleMapper();
		dest.name = source?.name ?? '';
		dest.roles = mapper.mapCollection(source?.roles);
		return dest;
	}

}
